import React, { createContext, useContext, useEffect, useState } from 'react';

const EnvironmentContext = createContext();

export const CONSOLE_ENVIRONMENTS = ['TEST', 'PROD'];
const STORAGE_KEY = 'consoleEnvironment';

export function normalizeEnvironment(value) {
  const raw = String(value || '').trim().toUpperCase();
  return CONSOLE_ENVIRONMENTS.includes(raw) ? raw : 'TEST';
}

export function getStoredEnvironment() {
  try {
    return normalizeEnvironment(localStorage.getItem(STORAGE_KEY));
  } catch {
    return 'TEST';
  }
}

export function EnvironmentProvider({ children }) {
  const [environment, setEnvironmentState] = useState(() => {
    try {
      return normalizeEnvironment(localStorage.getItem(STORAGE_KEY));
    } catch {
      return 'TEST';
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem(STORAGE_KEY, environment);
    } catch {
      // ignore quota errors
    }
  }, [environment]);

  const setEnvironment = (value) => {
    setEnvironmentState(normalizeEnvironment(value));
  };

  return (
    <EnvironmentContext.Provider value={{ environment, setEnvironment }}>
      {children}
    </EnvironmentContext.Provider>
  );
}

export function useEnvironment() {
  return useContext(EnvironmentContext);
}
